import { render, staticRenderFns } from "./FlowSupplierList.vue?vue&type=template&id=62b5fab5&scoped=true&"
import script from "./FlowSupplierList.vue?vue&type=script&lang=js&"
export * from "./FlowSupplierList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b5fab5",
  null
  
)

export default component.exports